import { useMemo, useState } from 'react';
import styled from 'styled-components';
import WeSpinToggleSwitch from '../../components/we-spin-toggle-switch.js';
import ButtonOutlined from '../../components/controls/buttons.js';

const LabelInnerWrapper = styled.div`
	display: flex;
	flex-grow: 1;
	justify-content: space-between;
	flex-direction: column;
`;

export default function OptionalImageLabel({ inputRef, inputValue, inputSetValue }) {
	const [isShown, setIsShown] = useState(false);

	const onSwitch = () => {
		// Reset optional image input on toggle off
		if (isShown) {
			inputSetValue(null);
		}
		setIsShown(!isShown);
	};

	const onFileBrowse = event => {
		event.stopPropagation();
		event.preventDefault();
		if (inputRef.current) {
			inputRef.current.click();
		}
	};

	const buttonLabel = useMemo(() => {
		return inputValue ? `Uploaded: ${inputValue?.name}` : 'Upload Image';
	}, [inputValue]);

	return (
		<LabelInnerWrapper>
			<WeSpinToggleSwitch label="Custom Image" isActive={isShown} onSwitch={onSwitch} />
			{isShown && (
				<ButtonOutlined className="u-mt2 u-mb1" type="button" onClick={onFileBrowse}>
					{buttonLabel}
				</ButtonOutlined>
			)}
		</LabelInnerWrapper>
	);
}
